export default Object.freeze({
    en: 'ampm',
    fr: '24hr',
});
